module.exports = __webpack_public_path__ + "img/file-icon.40a33d4c.png";